import PropTypes from 'prop-types';
import React from 'react';
import CommonIriDisplay from '../application-core/CommonIriDisplay';
import { getProjectFromGraph, sortResources } from '../core/utils/utils';
import TitledPanel from '../core/TitledPanel';

class Visibility extends React.Component {

    render() {

        const { sources, graph, viewLang, defaultLang, source, sourceType, componentIRI } = this.props;

        if (!sources) return null;
        // Should be loaded already so okay to sort on the data
        const sourcesList = Array.isArray(sources) ? sources : [sources];
        const otherSources = sourcesList.length === 1 ? sourcesList.filter(s => s !== componentIRI) : sourcesList;
        if (otherSources.length === 0) return null;
        const sortedResources = sortResources(otherSources, graph, "title", defaultLang);

        return (
            <TitledPanel dataTest="in-ontology" height="full" title="(View) In Ontology">
                {sortedResources.map(v =>
                    <CommonIriDisplay
                        id={v}
                        key={v}
                        loadComponents={true}
                        projectIRI={getProjectFromGraph(graph)}
                        handleNotAvailable={true}
                        property="visibility"
                        isReadOnly={true}
                        deeplink={true}
                        compact={true}
                        graph={graph}
                        source={source}
                        wrap={false}
                        viewLang={viewLang}
                        defaultLang={defaultLang}
                        sourceType={sourceType} />
                )}
            </TitledPanel>
        );
    }
}

Visibility.propTypes = {
    graph: PropTypes.string.isRequired,
    sources: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    componentIRI: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    sourceType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])
};

export default Visibility;